import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../../constant/constant";
import {
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  DialogActions,
  TextField,
  Box,
} from "@mui/material";
import dayjs from "dayjs";
//import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import AddIcon from '@mui/icons-material/Add';
import { decrypt } from "../../../components/cryptoUtil";
function SP_Button_AddOrganisation() {
  const [saving, setSaving] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const token = localStorage.getItem("token");
  const [softwares, setSoftwares] = useState([]);
  const [loadingSoftwares, setLoadingSoftwares] = useState(false);
  const [selectedSoftwareCode, setSelectedSoftwareCode] = useState("");
  const [confirmBeforeUpdate, setConfirmBeforeUpdate] = useState(false);

  const [OrganisationName, setOrganisationName] = useState("");
  const [OrganisationCode, setOrganisationCode] = useState("");
  const [OrganisationAddress, setOrganisationAddress] = useState("");
  const [OrganisationAdminName, setOrganisationAdminName] = useState("");
  const [OrganisationEmail, setOrganisationEmail] = useState("");
  const [validityValue, setValidityValue] = useState(dayjs());


  const userid = (JSON.parse(decrypt(localStorage.getItem('tokenData'))).userId);
  // Errors state
  const [errors, setErrors] = useState({});

  // Validation function
  const validateFields = () => {
    let tempErrors = {};

    if (!selectedSoftwareCode) tempErrors.software = "Please select a software";
    if (!OrganisationName) tempErrors.name = "Organisation name is required";
    else if (OrganisationName.length > 100)
      tempErrors.name = "Max 100 characters allowed";

    if (!OrganisationCode) tempErrors.code = "Organisation code is required";
    else if (OrganisationCode.length > 5)
      tempErrors.code = "Max 5 characters allowed";

    if (!OrganisationAddress) tempErrors.address = "Address is required";
    else if (OrganisationAddress.length > 150)
      tempErrors.address = "Max 150 characters allowed";

    if (!OrganisationAdminName)
      tempErrors.admin = "Admin name is required";

    if (!OrganisationEmail) {
      tempErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(OrganisationEmail))
        tempErrors.email = "Enter a valid email";
    }

    if (!validityValue) tempErrors.validity = "Validity date is required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  // Save Organisation
  // const handleConfirmSave = async () => {

  //   if (!validateFields()) return;

  //   try {
  //      setSaving(true); // start loading
  //     await axios.post(`${API_BASE_URL}/api/addorganisation`, {
  //       softgroup: selectedSoftwareCode,
  //       organisationname: OrganisationName,
  //       organisationcode: OrganisationCode,
  //       address: OrganisationAddress,
  //       adminname: OrganisationAdminName,
  //       adminemail: OrganisationEmail,
  //       validity: validityValue ? validityValue.toISOString() : null,
  //       createdby:userid,
  //     },{headers: {
  //   'Content-Type': 'application/json',
  //    "Authorization": `Bearer ${token}`, // optional, set default headers
  // },});

  //     setConfirmBeforeUpdate(false);
  //     setDialogOpen(false);
  //     setOrganisationName("");
  //     setOrganisationCode("");
  //     setOrganisationAddress("");
  //     setOrganisationAdminName("");
  //     setOrganisationEmail("");
  //     setSelectedSoftwareCode("");
  //   } catch (err) {
  //     console.error("Error saving organisation:", err);
  //   }
  // };
// Add this new state

// Update handleConfirmSave
const handleConfirmSave = async () => {
  if (!validateFields()) return;

  try {
    setSaving(true); // start loading
    await axios.post(`${API_BASE_URL}/api/addorganisation`, {
      softgroup: selectedSoftwareCode,
      organisationname: OrganisationName,
      organisationcode: OrganisationCode,
      address: OrganisationAddress,
      adminname: OrganisationAdminName,
      adminemail: OrganisationEmail,
      validity: validityValue ? validityValue.toISOString() : null,
      createdby: userid,
    }, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${token}`,
      },
    });

    setConfirmBeforeUpdate(false);
    setDialogOpen(false);

    // Reset fields
    setOrganisationName("");
    setOrganisationCode("");
    setOrganisationAddress("");
    setOrganisationAdminName("");
    setOrganisationEmail("");
    setSelectedSoftwareCode("");
    setValidityValue(dayjs());
  } catch (err) {
    console.error("Error saving organisation:", err);
  } finally {
    setSaving(false); // stop loading
  }
};

  // Fetch software list
  useEffect(() => {
    const fetchSoftwarelist = async () => {
      try {
        setLoadingSoftwares(true);
        const res = await axios.get(`${API_BASE_URL}/api/softwareslist`,{headers: {
    'Content-Type': 'application/json',
     "Authorization": `Bearer ${token}`, // optional, set default headers
  },});
        setSoftwares(res.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoadingSoftwares(false);
      }
    };
    fetchSoftwarelist();
  }, []);

  const handleUpdateClick = () => {
    if (validateFields()) setConfirmBeforeUpdate(true);
  };



useEffect(() => {
    if (!dialogOpen) {    
      setErrors({});
      setOrganisationName("");  
      setOrganisationCode("");
      setOrganisationAddress("");
      setOrganisationAdminName("");
      setOrganisationEmail("");
      setSelectedSoftwareCode("");

      setValidityValue(dayjs());
    }
  }, [dialogOpen]);


  return (
    <div>
      {/* Main Button */}
      <Button
      startIcon={<AddIcon />}
        variant="outlined"
       color="warning"
        fullWidth
        sx={{
          py: 1.5,
       //   fontWeight: "bold",
          borderRadius: 3,
          textTransform: "none",
        }}
        onClick={() => setDialogOpen(true)}
      >
        Add Organisation
      </Button>

      {/* Add Organisation Dialog */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle sx={{ bgcolor: "primary.main", color: "white", fontWeight: "bold" }}>
          Add New Organisation
        </DialogTitle>

        <DialogContent dividers sx={{ p: 3 }}>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Select Software</InputLabel>
            <Select
              value={selectedSoftwareCode}
              onChange={(e) => setSelectedSoftwareCode(e.target.value)}
              label="Select Software"
              error={!!errors.software}
            >
              {loadingSoftwares ? (
                <MenuItem disabled>
                  <CircularProgress size={20} />
                </MenuItem>
              ) : (
                softwares.map((s) => (
                  <MenuItem key={s.softgroupcode} value={s.softgroupcode}>
                    {s.softwarename}
                  </MenuItem>
                ))
              )}
            </Select>
            {errors.software && (
              <Typography color="error" variant="caption">
                {errors.software}
              </Typography>
            )}
          </FormControl>

          {/* Input Fields */}
          <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Organisation Name"
              value={OrganisationName}
              onChange={(e) => setOrganisationName(e.target.value)}
              error={!!errors.name}
              helperText={errors.name}
              required
              fullWidth
            />
            <TextField
              label="Organisation Code"
              value={OrganisationCode}
              onChange={(e) => setOrganisationCode(e.target.value)}
              error={!!errors.code}
              helperText={errors.code}
              required
              fullWidth
            />
            <TextField
              label="Address"
              value={OrganisationAddress}
              onChange={(e) => setOrganisationAddress(e.target.value)}
              error={!!errors.address}
              helperText={errors.address}
              required
              fullWidth
              multiline
              rows={2}
            />
            <TextField
              label="Admin Name"
              value={OrganisationAdminName}
              onChange={(e) => setOrganisationAdminName(e.target.value)}
              error={!!errors.admin}
              helperText={errors.admin}
              required
              fullWidth
            />
            <TextField
              label="Admin Email"
              type="email"
              value={OrganisationEmail}
              onChange={(e) => setOrganisationEmail(e.target.value)}
              error={!!errors.email}
              helperText={errors.email}
              required
              fullWidth
            />

            {/* Validity */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Validity (Date & Time)"
                value={validityValue}
                onChange={(newValue) => setValidityValue(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    error={!!errors.validity}
                    helperText={errors.validity}
                    required
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider>
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button onClick={() => setDialogOpen(false)} variant="outlined" color="inherit">
            Cancel
          </Button>
          <Button variant="contained" onClick={handleUpdateClick} color="secondary">
            Save Organisation
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Save Dialog */}
      <Dialog open={confirmBeforeUpdate} onClose={() => setConfirmBeforeUpdate(false)}>
        <DialogTitle sx={{ fontWeight: "bold" }}>Confirm Save</DialogTitle>
        <DialogContent dividers>
          <Typography>Are you sure you want to save this organisation?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmBeforeUpdate(false)} color="inherit">
            Cancel
          </Button>
          {/* <Button variant="contained" onClick={handleConfirmSave} color="secondary">
            Yes, Save
          </Button> */}


          <Button
  variant="contained"
  onClick={handleConfirmSave}
  color="secondary"
  disabled={saving} // disable while saving
  startIcon={saving && <CircularProgress size={20} color="inherit" />}
>
  {saving ? "Saving..." : "Yes, Save"}
</Button>

        </DialogActions>
      </Dialog>
    </div>
  );
}

export default SP_Button_AddOrganisation;
